module.exports = __webpack_public_path__ + "static/img/u1.5f49bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u1.png
// module id = gjia
// module chunks = 13